import type { CalendarEventActionSource } from './CalendarEventActionSource';
import { updateCalendarEvent as updateCalendarEventAction } from 'owa-calendar-events-actions';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import EventScope from 'owa-service/lib/contract/EventScope';

export default async function updateCalendarEvent(
    actionSource: CalendarEventActionSource,
    event: CalendarEvent,
    updates: Partial<CalendarEvent>
) {
    await new Promise<void>((resolve, reject) =>
        updateCalendarEventAction(
            event,
            updates as CalendarEvent,
            actionSource,
            EventScope.Default,
            resolve,
            reject
        )
    );
}
